import React, { useEffect, useState, Fragment } from "react";
import { ApiGetCall, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import { LogInSchoolID, typewatch, Camelcase, getAllBuildings, transformNameOfCol, revertColNames, formatDateToMMDDYYYY, getTypeWatchDelay, formatDecimal } from "../../JS/Common";
import { useContext } from "react";
import Pagination from "react-js-pagination";
import Deletepopup from "../../Components/Deletepopup";
import AlertsComp from "../../Components/AlertsComp";
import { CheckValidation } from "../../Components/Validations";
import CustomizationPopup from "../../Components/CustomizationPopup";
import PageHead from "../../Components/PageHead";
import Tab from "../../Components/Tab";
import Popup from "../../Components/Popup";
import useConfig from "../../Hooks/useConfig";
import { useStickyAction } from '../../Hooks';

export function ManageParts() {
  const { show_shop, show_part_order_module, organization, school } = useConfig();
  const [partsTabs, setPartsTabs] = useState({
    SchoolPartsTab: "active",
    MasterPartsTab: "",
    PartsOrdersTab: ""
  });
  const [SearchForSchool, setSearchForSchool] = useState("");
  const [SearchForMaster, setSearchForMaster] = useState("");
  const [tabflag, settabflag] = useState(1);
  const [GridData, setGridData] = useState([]);
  const [addpartsPopup, setAddpartsPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const initData = {
    partName: "",
    brandName: "",
    variantPrice: "",
    reorderQuantity: "",
    Handel: "",
    totalQuantity: "",
    atSchoolQtyCheck: ""
  }
  const [formData, setFormdata] = useState(initData);
  const [FlagForAddUpdateDelete, setFlagForAddUpdateDelete] = useState({
    Flag: "",
    IdForDelete: "",
  });
  const [NewAlerts, setNewAlerts] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [LimitForPagination, setLimitForPagination] = useState(25);
  const [pageRangeCount, setpageRangeCount] = useState(0);
  const showPagination = GridData?.length > 0;
  const [CustomizationModal, setCustomizationModal] = useState(false)
  const [columnNames, setColumnNames] = useState([]);
  const [Buildings, setBuildings] = useState([]);
  const [selectedBuildings, setSelectedBuildings] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [isMassEditActive, setIsMassEditActive] = useState(false);
  const [editedBuildings, setEditedBuildings] = useState({});
  const [unusedBuildingsRow, setUnusedBuildingsRow] = useState({});
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [showModals, setModals] = useState({
    createOrder: false,
    editCreateOrder: false,
    infoOnly: false,
    batchLogsModal: false,
    reOrder: false,
  });
  const [isAllChecked, setAllChecked] = useState(false);
  const [partOrderAccess, setPartOrderAccess] = useState(null);
  const [searchForPartsOrder, setSearchForPartsOrder] = useState('')
  const [sortingDetails, setSortingDetails] = useState({
    column: null,
    sFlag: "desc"
  });
  const [partsOrderFlag, setPartsOrderFlag] = useState(1);
  const [ItemsHover, setItemsHover] = useState(false);
  const [BatchData, setBatchData] = useState([]);
  const [showMoreDetails, setShowMoreDetails] = useState(null);
  const [ReOrderItems, setReOrderItems] = useState([]);
  const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

  useEffect(() => {
    ApiGetHeaders(13, setColumnNames)
    getAllBuildings(setBuildings, LogInSchoolID);
  }, []);

  useEffect(() => {
    if (partsTabs.MasterPartsTab == "active") {
      GetPartData(2, SearchForMaster ? SearchForMaster : null);
    } else if (partsTabs.SchoolPartsTab == "active") {
      GetPartData(1, SearchForSchool ? SearchForSchool : null);
    } else {
      GetPartsOrders(partsOrderFlag, searchForPartsOrder ? searchForPartsOrder : null, sortingDetails.column, sortingDetails.sFlag, false);
    }
  }, [currentPage, LimitForPagination]);

  async function GetPartData(flag, SearchString) {
    if (!SearchString) SearchString = null;
    var joinedString = null;

    if (columnNames.length > 0) {
      const oldColumns = columnNames.map(col => revertColNames(col));
      var joinedString = oldColumns.join('~');
    }
    typewatch(async function () {
      setLoading(true);
      await ApiGetCall(`/parts/list?schoolId=${LogInSchoolID}&search=${SearchString}&flag=${flag}&page=${currentPage}&limit=${LimitForPagination}&data=${joinedString}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          setLoading(false);
          const responseRs = JSON.parse(result);
          setpageRangeCount(responseRs?.msg?.total);
          setGridData(responseRs?.msg?.data?.length ? responseRs?.msg?.data : []);
          setPartOrderAccess(responseRs?.part_order_access);
          const markAsOrderedItems =
            responseRs?.msg?.data
              ?.filter(item => item.Stockflag == 1 && (item.mark_as_reorder != 1))
              ?.map(item => ({
                id: item.id,
                title: item.title,
                price: item.variant_price,
                quantity: "",
                building: null,
                Stockflag: item.Stockflag,
                MarkAsReOrder: item.mark_as_reorder,
              })) || [];
          setReOrderItems(markAsOrderedItems);
        }
      });
    }, getTypeWatchDelay(SearchString, 500));
  }

  async function GetPartsOrders(flag, SearchString, columnName, sFlag, toogleSort) {
    if (!SearchString) SearchString = null;
    if (!columnName) columnName = null;
    if (toogleSort) sFlag = sFlag == "asc" ? "desc" : "asc";
    setSortingDetails({ ...sortingDetails, column: columnName, sFlag: sFlag });
    typewatch(async function () {
      setLoading(true);
      await ApiGetCall(`/part-orders/list?flag=${flag}&schoolId=${LogInSchoolID}&search=${SearchString}&sortBy=${columnName}&sortByOrder=${sFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          setLoading(false);
          const responseRs = JSON.parse(result);
          setpageRangeCount(responseRs.msg.total)
          setGridData(responseRs.msg.data.length > 0 ? responseRs.msg.data : [])
        }
      });
    }, getTypeWatchDelay(SearchString, 500));
  }

  async function SavePart() {
    var BuildingData = [];
    if (FlagForAddUpdateDelete.Flag != 3) {
      var isFormValid = CheckValidation({ formID: "AddPartDiv" });
      if (!isFormValid) return;
      BuildingData = Object.entries(selectedBuildings)
        .map(([buildingId, { Quantity, UpdateFlag }]) => {
          if (FlagForAddUpdateDelete.Flag === 2) {
            if (UpdateFlag === 1) {
              return {
                building_id: buildingId,
                quantity: parseInt(Quantity) || 0, // Allow Quantity to be 0
              };
            }
            return null;
          } else {
            if (!Quantity || parseInt(Quantity) <= 0) return null;
            return {
              building_id: buildingId,
              quantity: parseInt(Quantity),
            };
          }
        })
        .filter(item => item != null);
    }

    setLoading(true);
    var raw = JSON.stringify({
      schoolId: LogInSchoolID,
      title: formData.partName,
      brandName: formData.brandName ? formData.brandName : null,
      price: formData.variantPrice,
      reminderQuantity: formData.reorderQuantity,
      uuid: FlagForAddUpdateDelete.IdForDelete,
      handle: formData.Handel,
      flag: FlagForAddUpdateDelete.Flag,
      buildingPartQuantity: BuildingData,
      schoolQuantity: formData.totalQuantity,
      totalPartQuantity: parseInt(totalQuantity)
    });
    await ApiPostCall("/parts/save-delete", raw).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        setLoading(false);
        if (result == "success") {
          if (FlagForAddUpdateDelete.Flag == 1) {
            var alertmsg = "Part Added Successfully";
          } else if (FlagForAddUpdateDelete.Flag == 2) {
            var alertmsg = "Part Updated Successfully";
          } else if (FlagForAddUpdateDelete.Flag == 3) {
            var alertmsg = "Part Delete Successfully";
          } else if (FlagForAddUpdateDelete.Flag == 4) {
            var alertmsg = "Part Added Successfully";
          }
          setNewAlerts(
            <AlertsComp show={true} variant="success" msg={alertmsg} />
          );
          setTimeout(() => {
            setNewAlerts(<AlertsComp show={false} />);
            setAddpartsPopup(false);
            setDeletePopup(false);
            setTotalQuantity(0)
            setFormdata(initData)
            if (FlagForAddUpdateDelete.Flag == 4) {
              setCurrentPage(1)
              setPartsTabs({ SchoolPartsTab: "", MasterPartsTab: "active" });
              GetPartData(2, null);
            } else {
              if (partsTabs.MasterPartsTab == "active") {
                GetPartData(2, null);
              } else {
                GetPartData(1, null);
              }
            }
          }, 2000);
        } else {
          setNewAlerts(
            <AlertsComp show={true} variant="danger" msg={result} />
          );
          setTimeout(() => {
            setNewAlerts(<AlertsComp show={false} />);
          }, 2000);
        }
      }
    });
  }
  async function GetDataById(id, customPrice) {
    setLoading(true);
    await ApiGetCall(`/parts/by-id?uuid=${id}`).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        setLoading(false);
        setFormdata({
          ...formData,
          partName: responseRs.title,
          brandName: responseRs.brand_name,
          variantPrice: customPrice ?? responseRs.variant_price,
          reorderQuantity: responseRs.reminder_quantity,
          Handel: responseRs.handle,
          totalQuantity: responseRs.school_quantity,
          atSchoolQtyCheck: responseRs.school_quantity,
        });
        if (responseRs.building_part.length > 0) {
          const buildingTotal = Object.values(responseRs.building_part).reduce((sum, building) => {
            return sum + (parseInt(building.building_quantity) || 0);
          }, 0);

          const total = buildingTotal + (parseInt(responseRs.school_quantity) || 0);
          setTotalQuantity(total);
        } else {
          setTotalQuantity(responseRs.school_quantity || 0);
        }
        const updatedSelectedBuildings = Buildings.reduce((acc, building) => {
          const matchingPart = responseRs.building_part.find(
            (part) => part.building_id === building.id
          );
          acc[building.id] = {
            Quantity: matchingPart ? matchingPart.building_quantity : 0,
          };
          return acc;
        }, {});

        setSelectedBuildings(updatedSelectedBuildings);
      }
    });
  }
  function renderContentForColumn(columnName, item) {
    const contentMap = {
      "Item": item.title,
      "Brand": item.brand_name || '-',
      "Price": `$${item?.custom_price ? formatDecimal(item?.custom_price) : formatDecimal(item?.variant_price) || '0'}`,
      "QTY": item.quantity || '0',
      "Reminder_QTY": item.reminder_quantity || '0',
      "Store_URL": item.handle || '-',
    };
    return contentMap[columnName] || null;
  }
  function handleSearchChange(e) {
    tabflag == 1 ? setSearchForSchool(e.target.value) : tabflag == 2 ? setSearchForMaster(e.target.value) : setSearchForPartsOrder(e.target.value);
    setCurrentPage(1);
    if (tabflag == 3) {
      GetPartsOrders(partsOrderFlag, e.target.value, null, sortingDetails.sFlag, false)
    } else {
      GetPartData(tabflag == 1 ? 1 : 2, e.target.value?.trim());
    }
  }
  function handleTabClick(tabType, partsOrderFlag) {
    if (tabType == "school") {
      GetPartData(1, null);
      setPartsTabs({ ...partsTabs, SchoolPartsTab: "active", MasterPartsTab: "", PartsOrdersTab: "" });
      setCurrentPage(1);
      settabflag(1);
      setSearchForMaster("");
      setSearchForSchool("");
      setSearchForPartsOrder("");
      setSelectedDevices([]);
      setBatchData([]);
      setIsMassEditActive(false);
    } else if (tabType == "master") {
      GetPartData(2, null);
      setPartsTabs({ ...partsTabs, SchoolPartsTab: "", MasterPartsTab: "active", PartsOrdersTab: "" });
      setCurrentPage(1);
      settabflag(2);
      setSearchForMaster("");
      setSearchForSchool("");
      setSearchForPartsOrder("");
      setSelectedDevices([]);
      setBatchData([]);
      setIsMassEditActive(false);
    } else if (tabType == "partsOrder") {
      GetPartsOrders(partsOrderFlag, searchForPartsOrder ? searchForPartsOrder : null, null, "desc", false);
      setPartsOrderFlag(partsOrderFlag);
      setPartsTabs({ ...partsTabs, SchoolPartsTab: "", MasterPartsTab: "", PartsOrdersTab: "active" });
      setCurrentPage(1);
      settabflag(3);
      setSearchForMaster("");
      setSearchForSchool("");
      setSearchForPartsOrder("");
      setSelectedDevices([]);
      setBatchData([]);
      setIsMassEditActive(false);
    }
  }
  function handleQuantityChange(e, buildingId) {
    let inputValue = e.target.value;
    if (inputValue == "0") {
      inputValue = "";
    } else {
      inputValue = inputValue.replace(/^0+/, '');
    }

    setSelectedBuildings((prevSelectedBuildings) => {
      const updatedSelectedBuildings = {
        ...prevSelectedBuildings,
        [buildingId]: {
          ...prevSelectedBuildings[buildingId],
          Quantity: inputValue,
          UpdateFlag: 1
        },
      };

      const buildingTotal = Object.values(updatedSelectedBuildings).reduce((sum, building) => {
        return sum + (parseInt(building.Quantity) || 0);
      }, 0);

      const total = buildingTotal + (parseInt(formData.totalQuantity) || 0);
      setTotalQuantity(total);
      return updatedSelectedBuildings;
    });
  }
  const handleSaveMassQtyChanges = async () => {
    const updatedParts = GridData.map((item) => {
      // Combine existing buildings and unused buildings
      const updatedBuildingQuantities = [
        // Map existing buildings
        ...item.building_part.map(building => {
          const editedBuildingQty = editedBuildings[item.id]?.[building.building_id]; // Ensure it's specific to the part
          return editedBuildingQty !== undefined
            ? { ID: building.building_id, Quantity: parseInt(editedBuildingQty) || 0 }
            : null;
        }).filter(Boolean),

        // Map unused buildings (if any exist for this item)
        ...(unusedBuildingsRow[item.id] || []).map(unused => ({
          ID: unused.building_id,
          Quantity: parseInt(unused.quantity) || 0
        }))
      ].filter(Boolean); // Remove null/undefined values

      return {
        partId: item.id,
        SchoolQuantity: item.school_quantity || 0,
        BuildingQuantity: updatedBuildingQuantities.length > 0 ? updatedBuildingQuantities : null
      };
    }).filter(Boolean);

    var raw = JSON.stringify({
      'schoolId': LogInSchoolID,
      'parts': updatedParts,
    });

    setLoading(true);
    await ApiPostCall("/parts/mass-update", raw).then((result) => {
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        setLoading(false);
        const responseRs = JSON.parse(result);
        if (responseRs.status == "success") {
          setUnusedBuildingsRow({});
          setNewAlerts(
            <AlertsComp show={true} variant="success" msg={"Quantity Updated Successfully."} />
          );
          setTimeout(() => {
            setNewAlerts(<AlertsComp show={false} />);
            setIsMassEditActive(false);
            GetPartData(1, null);
          }, 2000);
        } else {
          setNewAlerts(
            <AlertsComp show={true} variant="danger" msg={responseRs.status} />
          );
          setTimeout(() => {
            setNewAlerts(<AlertsComp show={false} />);
          }, 2000);
        }
      }
    });
  };

  async function SaveMasterParts() {
    var isFormValid
    if (showModals.createOrder) {
      isFormValid = CheckValidation({ formID: 'AddPartsList' });
    } else {
      isFormValid = CheckValidation({ formID: 'EditPartsList' });
    }
    if (!isFormValid) return;

    let PartsArray = []
    if (showModals.editCreateOrder) {
      PartsArray = BatchData?.part_order_items?.map(item => ({
        "id": item.partsku_id,
        "qty": item.requested_quantity == null || item.requested_quantity == "" ? 1 : parseInt(item.requested_quantity),
        "orderItemId": item.id,
        "building_id": item.building_id == "AtSchool" ? 0 : item.building_id,
        "ReorderFlag": item.Stockflag == 1 && item.MarkAsReOrder != 1 ? 1 : 2
      }))
    } else {
      PartsArray = [...selectedDevices?.map(item => ({
        "id": item.id,
        "qty": item.quantity == null || item.quantity == "" ? 1 : item.quantity,
        "orderItemId": null,
        "building_id": item.building == "AtSchool" ? 0 : item.building,
        "ReorderFlag": item.Stockflag == 1 && item.MarkAsReOrder != 1 ? 1 : 2
      })), ...ReOrderItems.filter(item => !selectedDevices.some(device => device.id === item.id)).map(item => ({
        "id": item.id,
        "qty": item.quantity == null || item.quantity == "" ? 1 : item.quantity,
        "orderItemId": null,
        "building_id": item.building == "AtSchool" ? 0 : item.building,
        "ReorderFlag": item.Stockflag == 1 && item.MarkAsReOrder != 1 ? 1 : 2
      }))];
    }
    if (PartsArray.length == 0) {
      setNewAlerts(<AlertsComp show={true} variant="danger" msg={"Please select at least one part to create an order."} />);
      setTimeout(() => {
        setModals({ ...showModals, createOrder: false });
        setNewAlerts(<AlertsComp show={false} />);
        GetPartData(1, null);
      }, 2000);
      return
    }
    var raw = JSON.stringify({
      "schoolId": LogInSchoolID,
      "orderId": showModals.editCreateOrder ? BatchData?.id : null,
      "parts": PartsArray
    })
    setLoading(true)
    await ApiPostCall("/part-orders/save", raw).then((result) => {
      if (result == undefined || result == "" || result == "Something Went Wrong") {
        setLoading(false);
        setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />)
        setTimeout(() => {
          setNewAlerts(<AlertsComp show={false} />);
        }, 2000);
      } else {
        setLoading(false);
        setNewAlerts(<AlertsComp show={true} variant="success" msg={showModals.editCreateOrder ? "Order edited successfully!" : "Order created successfully!"} />)
        setTimeout(() => {
          setModals({
            ...showModals,
            createOrder: false,
            editCreateOrder: false,
            infoOnly: false,
            batchLogsModal: false
          });
          handleTabClick('partsOrder', 1);
          setNewAlerts(<AlertsComp show={false} />);
        }, 2000);
      }
    })
  }

  async function GetBatchDetails(id) {
    setLoading(true);
    typewatch(async function () {
      await ApiGetCall(`/part-orders/by-id?uuid=${id}`).then((result) => {
        if (result == undefined || result == "") {
          setLoading(false);
          alert("Something went wrong");
        } else {
          setLoading(false);
          const responseRs = JSON.parse(result);
          if (responseRs.msg) {
            setBatchData(responseRs.msg)
          } else {
            setBatchData([]);
          }
        }
      });
    }, 500);
  }

  const handleChange = (e, item) => {
    const isChecked = e.target.checked;
    setSelectedDevices((prevState) =>
      isChecked
        ? prevState.some((device) => device.id === item.id)
          ? prevState
          : [...prevState, {
            id: item.id,
            title: item.title,
            price: item.variant_price,
            quantity: "",
            building: null,
            Stockflag: item.Stockflag,
            MarkAsReOrder: item.mark_as_reorder,
          }]
        : prevState.filter((device) => device.id !== item.id)
    );
  };

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    const pageItems = GridData?.map((item) => ({
      id: item.id,
      title: item.title,
      price: item.variant_price,
      quantity: "",
      building: null,
      Stockflag: item.Stockflag,
      MarkAsReOrder: item.mark_as_reorder,
    }));

    if (isChecked) {
      const newItems = pageItems.filter(
        (item) => !selectedDevices.some((selected) => selected.id === item.id)
      );
      setSelectedDevices((prevState) => [...prevState, ...newItems]);
    } else {
      const pageIds = GridData?.map((item) => item.id);
      const remainingDevices = selectedDevices.filter(
        (device) => !pageIds.includes(device.id)
      );
      setSelectedDevices(remainingDevices);
    }
  };

  const handleMasterModalInput = (e, id) => {
    let value = parseInt(e.target.value);
    if (isNaN(value)) value = null;
    setSelectedDevices((prev) =>
      prev.map((device) =>
        device.id === id ? { ...device, quantity: value } : device
      )
    );
  };

  useEffect(() => {
    if (GridData?.length > 0) {
      const allChecked = GridData?.every((item) =>
        selectedDevices.some((device) => device.id === item.id)
      );
      setAllChecked(allChecked);
    }
  }, [GridData, selectedDevices, currentPage, LimitForPagination]);

  const handlePartsSorting = (column) => {
    GetPartsOrders(partsOrderFlag, searchForPartsOrder, column, sortingDetails.sFlag, true);
  }

  const modalBody = (
    <div id="AddPartDiv" className="parent">
      <div className="row">
        <div className="col-md-6">
          <div className="col-12">
            <div className='FormLabel'>Part Name<label className='redText'>*</label></div>
            <div className="ps-0">
              <input type="text" autoComplete="off" name="partName" className="form-control partNamee" required
                value={formData.partName} onChange={(e) => setFormdata({ ...formData, partName: e.target.value })}
                disabled={FlagForAddUpdateDelete.Flag == 4} />
              <span className="form-text invalid-feedback" > *required </span>
            </div>
          </div>
          <div className="col-12 pt-3 ">
            <div className='FormLabel'>Price<label className='redText'>*</label></div>
            <div className=" pe-0">
              <div className="input-group">
                <span className="input-group-text">$</span>
                <input type="number" autoComplete="off" className="form-control" name="variantPrice" min={0}
                  placeholder="00" value={formData.variantPrice} required
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => setFormdata({ ...formData, variantPrice: e.target.value, })}
                  disabled={FlagForAddUpdateDelete.Flag == 4} />
                <span className="form-text invalid-feedback">*required </span>
              </div>
            </div>
          </div>
          {partsTabs.SchoolPartsTab === "active" && (
            <>
              <div className="col-12 pt-3" >
                <div className='FormLabel'>Reminder Quantity</div>
                <div className=" pe-0">
                  <input type="number" autoComplete="off" name="ReorderQuantity" className="form-control" placeholder="" min={0}
                    value={formData.reorderQuantity}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"]?.includes(e?.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => setFormdata({ ...formData, reorderQuantity: e.target.value, })} />
                </div>
              </div>

            </>
          )}
          <div className="col-12 pt-3">
            <div className='FormLabel'>Brand Name</div>
            <div className=" pe-0">
              <input type="text" autoComplete="off" name="brandName" className="form-control" value={formData.brandName}
                onChange={(e) => setFormdata({ ...formData, brandName: e.target.value })} disabled={FlagForAddUpdateDelete.Flag == 4} />
            </div>
          </div>
        </div>
        <div className='col-md-6'>
          {(FlagForAddUpdateDelete.Flag == 2 && Buildings.length > 0 && formData.atSchoolQtyCheck > 0) &&
            <div className="d-flex gap-2">
              <b>
                Note:
              </b>
              <label className="yellow-warning-text">
                It looks like buildings are configured. Kindly transfer all parts from the {school} to buildings.
              </label>
            </div>
          }
          <h5 className="mb-2 mt-2">Part Quantities</h5>
          <div className='p-1 greyBox data-table-container overflow-y-auto' style={{ maxHeight: '350px' }}>
            <table className="table data-table mb-0">
              <thead className='GridHeader'>
                <tr>
                  <th scope="col-6">Building</th>
                  <th scope="col-4">Quantity</th>
                </tr>
              </thead>
              <tbody>
                {Buildings?.length > 0 ?
                  Buildings?.map((item, j) => (
                    <tr className="my-1" key={j}>
                      <td className='py-1 col-6 text-wrap'>
                        {item.name}
                      </td>
                      <td className='py-1 col-4 ps-0'>
                        <input type="number" autoComplete="off" name="Quantity"
                          className="form-control"
                          value={selectedBuildings[item.id]?.Quantity || 0}
                          onChange={(e) => handleQuantityChange(e, item.id)}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                              e.preventDefault();
                            }
                          }}
                          placeholder="0" min={0} />
                      </td>
                    </tr>
                  ))
                  :
                  <tr>
                    <td colSpan={2} className="p-3 text-center"> No Building Found </td>
                  </tr>
                }
              </tbody>
              <tfoot>
                {(((FlagForAddUpdateDelete.Flag == 1 || FlagForAddUpdateDelete.Flag == 4) && Buildings.length == 0) ||
                  (FlagForAddUpdateDelete.Flag == 2 && (Buildings.length == 0 || (Buildings.length > 0 && formData.atSchoolQtyCheck > 0)))
                ) && (
                    <tr>
                      <td >
                        At {organization} :
                      </td>
                      <td className="ps-0 py-1">
                        <input type="number" autoComplete="off" name="Quantity"
                          className="form-control" min={0} value={formData.totalQuantity || 0}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            const schoolQuantity = parseInt(e.target.value) || 0;
                            setFormdata((prevFormData) => ({
                              ...prevFormData,
                              totalQuantity: schoolQuantity,
                            }));

                            const buildingTotal = Object.values(selectedBuildings).reduce((sum, building) => {
                              return sum + (parseInt(building.Quantity) || 0);
                            }, 0);

                            setTotalQuantity(buildingTotal + schoolQuantity);
                          }}
                        />
                      </td>
                    </tr>
                  )}
                <tr style={{ border: "transparent" }}>
                  <td className="fw-600">
                    Total  :
                  </td>
                  <td>{parseInt(totalQuantity)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  const AddMasterModalBody = (
    <>
      <label className=" text-primary mb-1"> * Marked for Reorder</label>
      <div id="AddPartsList" className="parent greyBox" style={{ maxHeight: '450px', overflowY: 'auto' }}>
        <div className="">
          <div className="GridHeader brdr-Btm">
            <div className="row mx-0">
              <div className="col-md-5">Selected Part</div>
              <div className="col-md-3">Building</div>
              <div className="col-md-2">Price</div>
              <div className="col-md-2">Qty</div>
            </div>
          </div>
          <div>
            {selectedDevices && selectedDevices.length > 0 ?
              selectedDevices?.map((deviceDetail) => (
                <div className="row OddEvenClass tableBorderHide mx-0" key={deviceDetail.id}>
                  <div className={`col-md-5 text-wrap ${deviceDetail.Stockflag == 1 && deviceDetail.MarkAsReOrder != 1 ? 'text-primary' : ''}`}>
                    {deviceDetail.title || "-"}
                  </div>
                  <div className="col-md-3 text-wrap">
                    <select
                      onChange={(e) => setSelectedDevices((prev) =>
                        prev.map((device) => device.id === deviceDetail.id ? { ...device, building: e.target.value } : device)
                      )}
                      required
                      className="w-100"
                    >
                      <option value="">Select Building</option>
                      {Buildings?.length > 0 ?
                        Buildings?.map((building, index) => (
                          <option value={building.id} key={index}>
                            {building.name}
                          </option>
                        )) :
                        <option value="AtSchool">At {organization}</option>
                      }
                    </select>
                    <span className="form-text invalid-feedback">
                      *required
                    </span>
                  </div>
                  <div className="col-md-2">
                    ${formatDecimal(deviceDetail.price) || "-"}
                  </div>
                  <div className="col-md-2">
                    <input
                      type="number"
                      min={1}
                      autoComplete="off"
                      className="form-control w-100"
                      placeholder="1"
                      defaultValue={deviceDetail.quantity}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                          e.preventDefault();
                        } else if (e.target.value.length === 0 && e.key === '0') {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { handleMasterModalInput(e, deviceDetail.id); }}
                    />
                  </div>
                </div>
              )) : <div className="OddEvenClass tableBorderHide mx-0 w-100 text-center">  No Parts Selected </div>
            }
            {ReOrderItems.length > 0 && ReOrderItems.filter(item => !selectedDevices.some(device => device.id === item.id)).length > 0 &&
              <>
                <div className="d-flex justify-content-between align-items-center w-100 mb-3 mt-5">
                  <label className="">
                    <b>Parts Due to Reorder</b>
                  </label>
                  <button
                    className="BorderBtn"
                    onClick={() => setReOrderItems([])}
                  >
                    Remove All
                  </button>
                </div>
                <div className="GridHeader brdr-Btm">
                  <div className="row mx-0">
                    <div className="col-md-5">Selected Part</div>
                    <div className="col-md-3">Building</div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-4">Price</div>
                        <div className="col-4">Qty</div>
                        <div className="col-4">Action</div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
            <div>
              {ReOrderItems.length > 0 && ReOrderItems.filter(item => !selectedDevices.some(device => device.id === item.id)).map((deviceDetail) => (
                <div className="row OddEvenClass tableBorderHide mx-0" key={deviceDetail.id}>
                  <div className={`col-md-5 text-wrap ${deviceDetail.Stockflag == 1 && deviceDetail.MarkAsReOrder != 1 ? 'text-primary' : ''}`}>
                    {deviceDetail.title || "-"}
                  </div>
                  <div className="col-md-3 text-wrap">
                    <select
                      onChange={(e) => setReOrderItems((prev) =>
                        prev.map((device) => device.id === deviceDetail.id ? { ...device, building: e.target.value } : device)
                      )}
                      required
                      className="w-100"
                    >
                      <option value="">Select Building</option>
                      {Buildings?.length > 0 ?
                        Buildings?.map((building, index) => (
                          <option value={building.id} key={index}>
                            {building.name}
                          </option>
                        )) :
                        <option value="AtSchool">At {organization}</option>
                      }
                    </select>
                    <span className="form-text invalid-feedback">
                      *required
                    </span>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-4">
                        ${formatDecimal(deviceDetail.price) || "-"}
                      </div>
                      <div className="col-md-4">
                        <input
                          type="number"
                          min={1}
                          autoComplete="off"
                          className="form-control w-100"
                          placeholder="1"
                          defaultValue={deviceDetail.quantity}
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                              e.preventDefault();
                            } else if (e.target.value.length === 0 && e.key === '0') {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            let value = parseInt(e.target.value);
                            if (isNaN(value)) value = null;
                            setReOrderItems((prev) => prev.map((device) => device.id === deviceDetail.id ? { ...device, quantity: value } : device
                            )
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <img src="/images/CancelIcon.svg" title="Remove" className="cursor-pointer" onClick={() => setReOrderItems((prevState) => prevState.filter((device) => device.id !== deviceDetail.id))} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <label className="text-center w-100 mt-2">
        Note : <span className=" text-warning">Parts without a building selection will be assigned to "At {organization}"</span>
      </label>
    </>
  )

  const EditMasterModalBody = (
    <>
      <div className="row mx-0 align-items-center">
        <div style={{ fontSize: '16px' }} className="mb-3">
          <b>Order No :</b> {BatchData?.part_order_num || "-"}
        </div>
      </div>
      <div id="EditPartsList" className="parent greyBox" style={{ maxHeight: '450px', overflowY: 'auto' }}>
        <div className="">
          <div className="GridHeader">
            <div className="row">
              <div className="col-md-6">Selected Part</div>
              <div className="col-md-3">Building</div>
              <div className="col-md-1">Price</div>
              <div className="col-md-2">Qty</div>
            </div>
          </div>
          <div>
            {BatchData?.part_order_items?.length > 0 &&
              BatchData?.part_order_items?.map((deviceDetail) => (
                <div className="row OddEvenClass tableBorderHide mx-0" key={deviceDetail.id}>
                  <div className="col-md-6 text-wrap">
                    {deviceDetail.requested_school_part || "-"}
                  </div>
                  <div className="col-md-3 text-wrap">
                    <select
                      value={deviceDetail.building_id === 0 ? "AtSchool" : deviceDetail.building_id}
                      onChange={(e) => {
                        setBatchData((prev) => ({
                          ...prev,
                          part_order_items: prev?.part_order_items?.map((device) => device.id === deviceDetail.id ? { ...device, building_id: e.target.value } : device)
                        }));
                      }}
                      required
                      className="w-100"
                    >
                      <option value="">Select Building</option>
                      {Buildings?.length > 0 ?
                        <>
                          {Buildings?.map((building, index) => (
                            <option value={building.id} key={index}>
                              {building.name}
                            </option>
                          ))}
                          {deviceDetail.building_id === 0 &&
                            <option value="AtSchool">At {organization}</option>
                          }
                        </>
                        :
                        <option value="AtSchool">At {organization}</option>
                      }
                    </select>
                    <span className="form-text invalid-feedback">
                      *required
                    </span>
                  </div>
                  <div className="col-md-1">
                    ${formatDecimal(deviceDetail.partsku_price) || "-"}
                  </div>
                  <div className="col-md-2">
                    <input
                      type="number"
                      min={1}
                      autoComplete="off"
                      className="form-control w-100"
                      placeholder="1"
                      defaultValue={deviceDetail.requested_quantity || 1}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                          e.preventDefault();
                        } else if (e.target.value.length === 0 && e.key === '0') {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        setBatchData((prev) => ({
                          ...prev,
                          part_order_items: prev?.part_order_items?.map((device) => device.id === deviceDetail.id ? { ...device, requested_quantity: e.target.value } : device)
                        }));
                      }} />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <label className="text-center w-100 mt-2">
        Note : <span className=" text-warning">Parts without a building selection will be assigned to "At {organization}"</span>
      </label>
    </>
  )

  const ShowDetailsOnly = (
    <>
      <div className="row mx-0 align-items-center">
        <div style={{ fontSize: '16px' }} className="mb-3">
          <b>Order No :</b> {BatchData?.part_order_num || "-"}
        </div>
      </div>
      <div id="PartsList" className="parent greyBox" style={{ maxHeight: '450px', overflow: "auto" }}>
        <div className="">
          <div className="GridHeader">
            <div className="row mx-0">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-6">Requested</div>
                  <div className="col-md-6">Fulfilled Part</div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="row">
                  <div className="col-md-6">Building</div>
                  <div className="col-md-6">Price</div>
                </div>
              </div>
              <div className="col-md-1">Action</div>
            </div>
          </div>
          <div>
            {BatchData?.part_order_items?.map((deviceDetail, index) => (
              <>
                <div className="row OddEvenClass tableBorderHide mx-0" key={index}>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        {showModals.infoOnly ? deviceDetail.requested_school_part || "-" : deviceDetail.requested_part_name || "-"}
                      </div>
                      <div className="col-md-6">
                        {showModals.infoOnly ? deviceDetail.fulfilled_device_name || "-" : deviceDetail.fulfilled_part_name || "-"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-6 text-break">{deviceDetail.building_name || "-"}</div>
                      <div className="col-md-6">${formatDecimal(deviceDetail.partsku_price) || "-"}</div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <img src="/images/UpRoundArrow.svg" title="Hide More Details" className={`cursor-pointer img-fluid ${showMoreDetails !== deviceDetail.id ? 'd-none' : ''}`} onClick={() => setShowMoreDetails(null)} />
                    <img src="/images/DownRoundArrow.svg" title="Show More Details" className={`cursor-pointer img-fluid ${showMoreDetails === deviceDetail.id ? 'd-none' : ''}`} onClick={() => setShowMoreDetails(deviceDetail.id)} />
                  </div>
                </div>
                {deviceDetail.id === showMoreDetails && (
                  <div className="p-3 OddEvenClass">
                    <div className="row mx-0 pb-2">
                      <div className="col-md-4 mb-1"><b className="pe-1">Requested Qty </b>: {deviceDetail.requested_quantity}</div>
                      <div className="col-md-4 mb-1"><b className="pe-1">Fulfilled Qty </b>: {deviceDetail.fulfilled_quantity}</div>
                      <div className="col-md-4 mb-1"><b className="pe-1">Remaining Qty </b>: {deviceDetail.requested_quantity - deviceDetail.fulfilled_quantity > 0 ? deviceDetail.requested_quantity - deviceDetail.fulfilled_quantity : "0"}</div>
                      <div className="w-100 mt-2"><b className="pe-1">Note </b> : {deviceDetail.note || "-"}</div>
                    </div>
                  </div>
                )}
              </>
            ))
            }
          </div>
        </div>
      </div>
    </>
  );

  return (
    <Fragment>
      <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
        setCurrentPage={setCurrentPage} heading={"Manage Parts"} handleSearch={handleSearchChange}
        loading={loading} Alerts={NewAlerts} showsearch={true} />
      <div className="GridBox mt-2 p-3">
        <div className="col-12 ">
          <div className="row align-items-center">
            <div className="col-md-9 px-0">
              <ul className="nav nav-tabs px-3">
                <Tab isActive={partsTabs.SchoolPartsTab == 'active'}
                  label={`${organization} Parts`} onClick={() => handleTabClick('school')} col={'col-md-3'} />
                <Tab isActive={partsTabs.MasterPartsTab == 'active'}
                  label="Master Parts" onClick={() => handleTabClick('master')} col={'col-md-3'} />
                {show_part_order_module && partOrderAccess != null && partOrderAccess == 1 &&
                  <Tab isActive={partsTabs.PartsOrdersTab == 'active'}
                    label="Parts Orders" onClick={() => handleTabClick('partsOrder', 1)} col={'col-md-3'} />
                }
              </ul>
            </div>

          </div>
          <div className="col-xl-8 offset-xl-4 col-12 text-end pt-2">
            {partsTabs.SchoolPartsTab == "active" && (
              <>
                {GridData?.length > 0 && (
                  <label className="BorderBtn text-center" onClick={() => setIsMassEditActive(!isMassEditActive)}>
                    {isMassEditActive ? "Cancel Mass Edit" : "Mass Edit Quantities"}
                  </label>
                )}
                {isMassEditActive && (
                  <label className="BorderBtn text-center" onClick={handleSaveMassQtyChanges}>
                    Save Changes
                  </label>
                )}
                <label className="BorderBtn text-center" title="Add Part"
                  onClick={(e) => {
                    setAddpartsPopup(true); setSelectedBuildings([]); setFlagForAddUpdateDelete({ ...FlagForAddUpdateDelete, Flag: 1 });
                    setFormdata((prevState) => ({ ...prevState, partName: "", variantPrice: "", reorderQuantity: "", brandName: "", totalQuantity: "" }));
                  }}> Add Part <img src="/images/AddInventory.svg" className="img-fluid ps-2" /> </label>
              </>
            )}
            {show_part_order_module && partsTabs.SchoolPartsTab == "active" && partOrderAccess != null && partOrderAccess == 1 && GridData?.length != 0 &&
              (
                <label
                  className="cursor-pointer"
                  style={{ borderRadius: "10px", background: "var(--primary-color)", color: "white", padding: "5px 13px 5px 13px" }}
                  onClick={() => {
                    if (selectedDevices.length == 0 && ReOrderItems.length == 0) {
                      setNewAlerts(
                        <AlertsComp
                          variant="danger"
                          show={true}
                          msg={`Please select at least one part to create an order.`}
                        />
                      );
                      setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                      }, 3000)
                    } else {
                      setModals({ ...showModals, createOrder: true })
                    }
                  }}>
                  Create Order
                </label>
              )}
          </div>
          {partsTabs.PartsOrdersTab == 'active' && (
            <div className='row align-items-center mb-3 ps-1 pt-3'>
              <div className='col-md-8 d-flex gap-3'>
                <div className="form-check ">
                  <input className="form-check-input" type="radio" name="partsOrder" checked={partsOrderFlag == 1} onClick={() => handleTabClick('partsOrder', 1)} />
                  <label className="form-check-label">Pending Orders</label>
                </div>
                <div className="form-check ">
                  <input className="form-check-input" type="radio" name="partsOrder" checked={partsOrderFlag == 2} onClick={() => handleTabClick('partsOrder', 2)} />
                  <label className="form-check-label">Past Orders</label>
                </div>
              </div>
            </div>
          )}

          <div className={`greyBox mt-3`}>
            <div className="data-table-container" ref={tableWrapperRef}>
              <table className="table data-table mb-0">
                <thead className="GridHeader">
                  <tr>
                    {show_part_order_module && GridData?.length != 0 && partOrderAccess != null && partOrderAccess == 1 &&
                      partsTabs.SchoolPartsTab == "active" && (
                        <th scope="col">
                          <input
                            className="form-check-input mt-1 cursor-pointer"
                            type="checkbox"
                            name="allSelect"
                            onChange={handleSelectAllChange}
                            checked={isAllChecked}
                          />
                        </th>
                      )
                    }

                    {partsTabs.PartsOrdersTab != "active" &&
                      columnNames?.filter((item) => partsTabs.SchoolPartsTab == "active" ? item : item != 'QTY')?.map((item) => {
                        const columnName = item.replace(/_/g, ' ');
                        const transformedName = transformNameOfCol(columnName);
                        if (!transformedName) return null;
                        return (
                          <th key={item} scope="col" className='fw-600' >
                            {Camelcase(transformedName)}
                          </th>
                        );
                      })}
                    {partsTabs.SchoolPartsTab == "active" ? (
                      <>
                        <th scope="col" className=" fw-600"> Building </th>
                      </>
                    ) : partsTabs.MasterPartsTab == "active" ? (
                      <>
                        <th scope="col" className="fw-600">Add to Parts Inventory</th>
                      </>
                    ) : (
                      <>
                        <th scope="col" className="cursor-pointer fw-600" title="Sort by Order No." onClick={() => handlePartsSorting("part_order_num")}>Order No.
                          <img
                            src="/images/sortbynew.svg"
                            className="img-fluid ps-2 sortbyClass"
                          />
                        </th>
                        <th scope="col" className="cursor-pointer fw-600" title="Sort by Items" onClick={() => handlePartsSorting("items")}> Items
                          <img
                            src="/images/sortbynew.svg"
                            className="img-fluid ps-2 sortbyClass"
                          />
                        </th>
                        <th scope="col" className="cursor-pointer fw-600" title="Sort by Requested Date" onClick={() => handlePartsSorting("request_date")}> Requested Date
                          <img
                            src="/images/sortbynew.svg"
                            className="img-fluid ps-2 sortbyClass"
                          />
                        </th>
                        {partsOrderFlag == 2 && (
                          <th scope="col" className="cursor-pointer fw-600" title="Sort by Fulfilled Date" onClick={() => handlePartsSorting("fulfilled_at")}> Fulfilled Date
                            <img
                              src="/images/sortbynew.svg"
                              className="img-fluid ps-2 sortbyClass"
                            />
                          </th>
                        )}
                        {partsOrderFlag == 1 && (
                          <th scope="col" className="cursor-pointer fw-600" title="Sort by Status" onClick={() => handlePartsSorting("order_status")}> Status
                            <img
                              src="/images/sortbynew.svg"
                              className="img-fluid ps-2 sortbyClass"
                            />
                          </th>
                        )}
                        <th scope="col" className=" fw-600"> Action </th>
                      </>
                    )}
                    {partsTabs.PartsOrdersTab != "active" &&
                      <th scope="col" className=" fw-600">
                        <div className="d-flex">
                          {show_shop ? partsTabs.MasterPartsTab == "active" ? "Purchase" : "Reorder" : ""}
                          {partsTabs.MasterPartsTab == "active" && (
                            <div className="EditHeaderIconDiv">
                              <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2"
                                title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                            </div>
                          )}
                        </div>
                      </th>
                    }
                    {partsTabs.SchoolPartsTab == "active" && (
                      <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                        <div className="d-flex">
                          Action
                          <div className="EditHeaderIconDiv">
                            <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2"
                              title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                          </div>
                        </div>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {GridData?.length != 0 ? (
                    GridData?.map((item, i) => {
                      var returData = (
                        <tr key={i} className='OddEvenClass tableBorderHide' style={{ height: "30px" }}>
                          {show_part_order_module && partOrderAccess != null && partOrderAccess == 1 &&
                            partsTabs.SchoolPartsTab == "active" && (
                              <td className="py-12">
                                <input
                                  type="checkbox"
                                  className="form-check-input cursor-pointer"
                                  onChange={(e) => handleChange(e, item)}
                                  checked={selectedDevices.some(device => device.id === item.id)}
                                />
                              </td>
                            )}
                          {partsTabs.PartsOrdersTab != "active" &&
                            columnNames?.filter((item) => partsTabs.SchoolPartsTab == "active" ? item : item != 'QTY')?.map(header => (
                              <td className="py-12" key={header} style={{ whiteSpace: 'break-spaces' }}>
                                {renderContentForColumn(header, item)}
                              </td>
                            ))
                          }
                          {partsTabs.SchoolPartsTab == "active" ? (
                            <>
                              <td className="py-12">
                                {isMassEditActive ? (
                                  <>
                                    {item?.building_part?.length > 0 ?
                                      item?.building_part?.map((building, index) => (
                                        <div key={index} className="d-flex gap-2 mx-0 mb-2">
                                          <div style={{ width: "200px" }}>
                                            <label className="text-wrap">{building.building_details?.name} : &nbsp;</label>
                                          </div>
                                          <div style={{ width: "100px" }}>
                                            <input
                                              type="number"
                                              className="form-control"
                                              min={0}
                                              defaultValue={building.building_quantity}
                                              onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onChange={(e) =>
                                                setEditedBuildings((prev) => ({
                                                  ...prev,
                                                  [item.id]: {
                                                    ...(prev[item.id] || {}),
                                                    [building.building_id]: e.target.value,
                                                  },
                                                }))
                                              }
                                            />
                                          </div>
                                        </div>
                                      ))
                                      : <label className="w-100">-</label>
                                    }
                                    {unusedBuildingsRow[item.id]?.map((row, index) => (
                                      <div className="d-flex gap-2 mx-0 mb-2">
                                        <div style={{ width: "200px" }}>
                                          <select
                                            value={row.building_id}
                                            className="col-5"
                                            onChange={(e) => {
                                              const newBuildingId = e.target.value;
                                              setUnusedBuildingsRow((prev) => ({
                                                ...prev,
                                                [item.id]: prev[item.id].map((r, i) =>
                                                  i === index ? { ...r, building_id: newBuildingId } : r
                                                ),
                                              }));
                                            }}
                                          >
                                            <option value="0">Building</option>
                                            {/* --- Filter Out Selected Buildings --- */}
                                            {item?.unusedbuilding
                                              ?.filter((item1) =>
                                                !unusedBuildingsRow[item.id]?.some((r, i) =>
                                                  String(r.building_id) === String(item1.id) && i !== index
                                                ))
                                              ?.map((item1, j) => (
                                                <option value={item1.id} key={j}>
                                                  {item1.name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                        <div style={{ width: "100px" }}>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={row.quantity}
                                            min={0}
                                            onKeyDown={(e) => {
                                              if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onChange={(e) => {
                                              const newQuantity = e.target.value;
                                              setUnusedBuildingsRow((prev) => ({
                                                ...prev,
                                                [item.id]: prev[item.id].map((r, i) =>
                                                  i === index ? { ...r, quantity: newQuantity } : r
                                                ),
                                              }));
                                            }}
                                          />
                                        </div>
                                        <div className="col-3 ps-1">
                                          <button
                                            className="BorderBtn"
                                            onClick={() => {
                                              setUnusedBuildingsRow((prev) => ({
                                                ...prev,
                                                [item.id]: prev[item.id].filter((_, i) => i !== index),
                                              }));
                                            }}
                                          >
                                            Remove
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                    <div className="d-flex gap-2">
                                      <div style={{ width: "200px" }}>
                                        <select
                                          value={selectedBuildings[item.id]?.building_id || "0"}
                                          onChange={(e) => {
                                            const selectedBuildingId = e.target.value;
                                            setSelectedBuildings((prev) => ({
                                              ...prev,
                                              [item.id]: {
                                                building_id: selectedBuildingId,
                                                quantity: prev[item.id]?.quantity || "", // Keep existing quantity if present
                                                showInput: selectedBuildingId !== "0", // Show input if a valid building is selected
                                              },
                                            }));
                                          }}
                                        >
                                          <option value="0">Building</option>
                                          {/* --- Filter Out Selected Buildings --- */}
                                          {item?.unusedbuilding
                                            ?.filter((item1) => !unusedBuildingsRow[item.id]?.some((row) => String(row.building_id) === String(item1.id)))
                                            ?.map((item1, j) => (
                                              <option value={item1.id} key={j}>
                                                {item1.name}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                      {selectedBuildings[item.id]?.showInput && (
                                        <>
                                          <div style={{ width: "100px" }}>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={selectedBuildings[item.id]?.quantity || ""}
                                              min={0}
                                              onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onChange={(e) => {
                                                setSelectedBuildings((prev) => ({
                                                  ...prev,
                                                  [item.id]: {
                                                    ...prev[item.id],
                                                    quantity: e.target.value,
                                                  },
                                                }));
                                              }} />
                                          </div>
                                          <div style={{ width: "100px" }}>
                                            <button
                                              className="BorderBtn"
                                              onClick={() => {
                                                if (!selectedBuildings[item.id]?.quantity || selectedBuildings[item.id]?.quantity <= 0) {
                                                  setNewAlerts(<AlertsComp show={true} variant={"danger"} msg={"Please enter a valid quantity"} />);
                                                  setTimeout(() => {
                                                    setNewAlerts(<AlertsComp show={false} />)
                                                  }, 2000);
                                                  return;
                                                }

                                                setUnusedBuildingsRow((prev) => ({
                                                  ...prev,
                                                  [item.id]: [
                                                    ...(prev[item.id] || []),
                                                    {
                                                      id: Date.now(), // Unique key for each row
                                                      building_id: selectedBuildings[item.id].building_id,
                                                      quantity: selectedBuildings[item.id].quantity,
                                                    },
                                                  ],
                                                }));

                                                // Reset dropdown and quantity after adding
                                                setSelectedBuildings((prev) => ({
                                                  ...prev,
                                                  [item.id]: { building_id: "0", quantity: "", showInput: false },
                                                }));
                                              }}
                                            >
                                              Add
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </div>

                                  </>
                                ) : (
                                  item?.building_part?.length > 0 ?
                                    item?.building_part?.map((building) => (
                                      <div className="text-nowrap mb-1">{building.building_details?.name} : {building.building_quantity} <br /></div>))
                                    : "-"
                                )}

                              </td>

                              {show_shop ?
                                (item.Stockflag == 1 && item?.mark_as_reorder != 1
                                  ? (
                                    <td className="py-12">
                                      <label className="font-11 px-2 py-0 cursor-pointer" style={{ color: 'red', border: '1px solid red', borderRadius: '30px' }}
                                        onClick={(e) => {
                                          if (partOrderAccess != null && partOrderAccess == 1) {
                                            let editedItem = {
                                              id: item.id,
                                              title: item.title,
                                              price: item.variant_price,
                                              quantity: 1,
                                              building: null,
                                              Stockflag: item.Stockflag,
                                              MarkAsReOrder: item.mark_as_reorder,
                                            };
                                            setSelectedDevices((prevState) => {
                                              const exists = prevState.some((device) => device.id === item.id);
                                              return exists
                                                ? prevState.map((device) =>
                                                  device.id === item.id ? editedItem : device
                                                )
                                                : [...prevState, editedItem];
                                            });
                                          } else {
                                            window.open(item.handle);
                                          }
                                        }}
                                        partid={item.id}>Reorder</label>
                                    </td>
                                  ) : (
                                    <td className="py-12">-</td>
                                  )) : <td></td>}

                              <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`} >
                                <img src="/images/EditIconNew.svg" title="Edit Part" className="img-fluid pe-2 cursor-pointer partsgetID" partid={item.id}
                                  onClick={(e) => {
                                    setAddpartsPopup(true); setSelectedBuildings([]); setFlagForAddUpdateDelete({ ...FlagForAddUpdateDelete, Flag: 2, IdForDelete: item.id });
                                    GetDataById(item.id);
                                  }} />
                                <img src="/images/DeleteIcon.svg" title="Delete Part" className="img-fluid cursor-pointer" partid={item.id}
                                  onClick={(e) => { setDeletePopup(true); setFlagForAddUpdateDelete({ ...FlagForAddUpdateDelete, Flag: 3, IdForDelete: item.id }); }} />
                              </td>

                            </>
                          ) : partsTabs.MasterPartsTab == "active" ? (
                            <>
                              <td className="py-12">
                                <img src="/images/PurchaseParts.svg" className="img-fluid cursor-pointer" title={`Add to Parts Inventory`}
                                  onClick={(e) => {
                                    setAddpartsPopup(true);
                                    setSelectedBuildings([]);
                                    setFlagForAddUpdateDelete({ ...FlagForAddUpdateDelete, Flag: 4, IdForDelete: item.id });
                                    GetDataById(item.id, item.custom_price);
                                  }}
                                  partid={item.id}
                                />
                              </td>
                              {show_shop ?
                                <td className="py-12">
                                  <label className="font-11 px-2 py-0 cursor-pointer" style={{ color: 'var(--primary-color)', border: '1px solid var(--primary-color)', borderRadius: '30px' }}
                                    partid={item.id} onClick={(e) => window.open(item.handle)}>Purchase</label>
                                </td>
                                : <td></td>}
                            </>
                          ) : (
                            <>
                              <td className="py-12">
                                {item.part_order_num || "-"}
                              </td>
                              <td className={`py-12 ${ItemsHover === item.id ? 'overflow-visible' : ''}`} onMouseLeave={() => setItemsHover(false)}>
                                <div className=" position-relative">
                                  <label className={`${partsOrderFlag == 1 ? 'text-decoration-underline cursor-pointer' : ''}`}
                                    onMouseEnter={() => setItemsHover(item.id)}
                                  >
                                    {item.items}
                                  </label>
                                  {partsOrderFlag == 1 && ItemsHover === item.id && (
                                    <div className=" position-absolute bg-white shadow rounded-4 p-3" style={{ zIndex: 999 }}>
                                      <div
                                        className="row mx-0 overflow-x-hidden overflow-y-scroll"
                                        style={{ width: '450px', maxHeight: '150px' }}
                                      >
                                        <div className="row mx-0 pb-2 mb-2 brdr-Btm">
                                          <div className="col-md-10"><b>Item Name</b></div>
                                          <div className="col-md-2"><b> Qty </b></div>
                                        </div>
                                        {item.item_details?.map((innerItems, index) => (
                                          <div className="row mx-0 py-2" key={index}>
                                            <div className="col-md-10 text-wrap">{innerItems.name}</div>
                                            <div className="col-md-2">{innerItems.qty}</div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="py-12">
                                {item.request_date ? formatDateToMMDDYYYY(item.request_date) : "-"}
                              </td>
                              {partsOrderFlag == 2 && (
                                <td className="py-12">
                                  {item.fulfilled_at ? formatDateToMMDDYYYY(item.fulfilled_at) : "-"}
                                </td>
                              )}
                              {partsOrderFlag == 1 && (
                                <td className="py-12">
                                  {item.batch_status_text || "-"}
                                </td>
                              )}
                              <td className="py-12">
                                {item.batch_status == "0" ?
                                  partsOrderFlag == 1 ? (
                                    <img src="/images/EditIconNew.svg" title="Edit Details" className="img-fluid pe-2 cursor-pointer" onClick={() => { GetBatchDetails(item.id); setModals({ ...showModals, editCreateOrder: true }) }} />
                                  ) : (
                                    <>
                                      <img src="/images/LogBatchIcon.svg" title="Order History" height={28} width={28} className="img-fluid pe-2 cursor-pointer" onClick={() => { GetBatchDetails(item.id); setModals({ ...showModals, infoOnly: true }); }} />
                                    </>
                                  ) : (
                                    <>
                                      <img src="/images/LogBatchIcon.svg" title="Order History" height={28} width={28} className="img-fluid pe-2 cursor-pointer" onClick={() => { GetBatchDetails(item.id); setModals({ ...showModals, infoOnly: true }); }} />
                                    </>

                                  )}

                              </td>
                            </>
                          )}

                        </tr>
                      );
                      return returData;
                    })
                  ) : (
                    <tr> <td colSpan={18} className="p-3 text-center"> No Record Found </td> </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {showPagination && (
            <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
              pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination} onChange={(e) => setCurrentPage(e)}
              color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
              itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
          )}
        </div>
      </div>

      <Popup
        isshow={showModals.createOrder}
        size={"lg"}
        title={'Create Parts Order'}
        closePopup={(e) => { setModals({ ...showModals, createOrder: false }); setSelectedDevices([]); GetPartData(1, null); }}
        modalBody={AddMasterModalBody}
        handleSave={SaveMasterParts}
        visibleSaveBtn={true}
        btnText={'Send Order'}
      />
      <Popup
        isshow={showModals.editCreateOrder}
        size={"lg"}
        title={'Edit Parts Order'}
        closePopup={(e) => setModals({ ...showModals, editCreateOrder: false })}
        modalBody={EditMasterModalBody}
        handleSave={SaveMasterParts}
        visibleSaveBtn={true}
        btnText={'Send Order'}
      />
      <Popup
        isshow={showModals.infoOnly}
        size={"xl"}
        title={'Parts Order History'}
        closePopup={(e) => {
          setModals({ ...showModals, infoOnly: false });
          setBatchData([]);
          setShowMoreDetails(null);
        }
        }
        modalBody={ShowDetailsOnly}
      />
      <Popup isshow={addpartsPopup} size={"lg"} title={FlagForAddUpdateDelete.Flag == 1 ? 'Add Part' : FlagForAddUpdateDelete.Flag == 2 ? 'Edit Part' : `Add to Parts Inventory`}
        closePopup={(e) => { setAddpartsPopup(false); setFormdata(initData); setTotalQuantity(0); }}
        modalBody={modalBody} handleSave={SavePart} visibleSaveBtn={true} btnText={
          FlagForAddUpdateDelete.Flag == 1 ? 'Add Part'
            : FlagForAddUpdateDelete.Flag == 2 ? 'Update Part'
              : 'Save Part'
        } />

      <Deletepopup text={`You won't be able to revert this!`} deletePopup={deletePopup} size="xl" deletePart={SavePart} DeleteShowClose={(e) => setDeletePopup(false)} />

      {CustomizationModal == true && (
        <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Manage Parts'} GetCall={() => ApiGetHeaders(13, setColumnNames)} />
      )}
    </Fragment>

  );
}
